import React, {useEffect, useRef, useState} from 'react';
import {StyledEmailTd} from './style';

export function EmailTd(props) {
    const { email } = props;

    const [black, setBlack] = useState(true);
    const ref = useRef(null);

    const height = ref.current ? ref.current.clientHeight : 0;

    useEffect(() => {
        const height = ref.current ? ref.current.clientHeight : 0;
        setBlack(height < 30);
    }, [height]);

    if (!email || email === '-')
        return '-';

    const array = email.split("@");
    const front = array[0];
    const domain = `@${array[1]}`;

    return (
        <StyledEmailTd ref={ref}>
            <div className="ellipsis-div ">
                { front }
                <span className={`domain ${black ? ' black' : ''}`}>{ domain }</span>
            </div>
        </StyledEmailTd>
    );
}

export const EmailTdWidth = 180;
